import * as React from 'react';
import { useIntl } from 'react-intl';
import CmdBox from '@commander-services/cmd-box';
import { useSetRecoilState } from 'recoil';
import GoogleMap from './GoogleMapLayer';
import Bounds from './GoogleMapLayer/Bounds';
import { IPositionInGraph } from '..';
import Config from '../../../../../config';
import ToolbarLayer from './ToolbarLayer';
import { vehicleFocusAtom } from '../../../OnlineMapNew/OnlineMapState';

interface IPositionDetailProps {
  position: IPositionInGraph | null;
  vehicleId: number;
}

export default function PositionMap(props: IPositionDetailProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [googleMap, setGoogleMap] = React.useState<google.maps.Map | undefined>();
  const setVehicleFocus = useSetRecoilState<boolean>(vehicleFocusAtom);

  React.useEffect(() => {
    setVehicleFocus(true);
  }, [props.position, setVehicleFocus]);

  return (
    <CmdBox id="positionMap" title={f({ id: 'tripsOverview.section.map' })}>
      <div style={{ position: 'relative', width: '100%', height: 400 }}>
        <div
          id="graph-google-map"
          style={{ width: '100%', height: '100%', position: 'absolute', overflow: 'hidden' }}
        >
          <GoogleMap
            googleMap={googleMap}
            setGoogleMap={setGoogleMap}
            position={props.position}
            vehicleId={props.vehicleId}
          />
          <Bounds googleMap={googleMap} lat={props.position?.lat} lng={props.position?.lng} />
          <ToolbarLayer
            googleMap={googleMap}
            vehicleFocusControl={Config.onlineMap.toolbar.vehicleFocusControl}
          />
        </div>
      </div>
    </CmdBox>
  );
}
